import { Icon, Page } from '@/components';
import { useGetHomeDetailsQuery } from '@/redux';
import {
  PersonalizationSummaryTabContent,
  TrackPersonalizationActivityModal,
  useTrackPersonalizationActivityModal,
} from '@/views';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import styles from './PersonalizationSummaryPublicPage.module.scss';

const useId = () => {
  const { id } = useParams<'id'>();
  return id!;
};

function _PersonalizationSummaryPublicPage() {
  const { t } = useTranslation();
  const id = useId();
  const { data } = useGetHomeDetailsQuery({ id, allowAnonymous: true });
  const title = data?.homeNumber
    ? `${data.homeNumber} - ${t('personalization.summary.title')}`
    : t('fetchFallbackTitle');
  const activityModal = useTrackPersonalizationActivityModal(id);

  if (!data) return <></>;
  return (
    <>
      <Page htmlTitle={title}>
        <Page.Body
          xs={{ span: 22, offset: 1 }}
          lg={{ span: 22, offset: 1 }}
          xl={{ span: 20, offset: 1 }}
          xxl={{ span: 18, offset: 3 }}
        >
          <Page.Card
            title={
              <Typography.Text className={styles.title}>
                {title}
              </Typography.Text>
            }
            icon={<Icon type="home" />}
            color="#107CC7"
          >
            <PersonalizationSummaryTabContent
              homeId={id}
              personalizationHistory={data?.personalizationHistory}
              communityId={data?.communityId}
              isPublic
            />
          </Page.Card>
        </Page.Body>
      </Page>
      <TrackPersonalizationActivityModal {...activityModal} />
    </>
  );
}

export const PersonalizationSummaryPublicPage =
  _PersonalizationSummaryPublicPage;
